// External modules
import React from 'react';
import PropTypes from 'prop-types';

import { Fab } from '@material-ui/core';

// Internal modules
import styles from './ACButtonV2.module.scss';

function ACButtonV2({ className, disabled, Icon, iconLast, onClickFunc, spanStyle, style, text }) {
  let values = [
    <span
      key="text"
      style={{
        ...spanStyle,
      }}
    >
      {text}
    </span>,
  ];

  if (Icon) {
    const iconComponent = <Icon key="icon" width="1.5em" />;

    if (!iconLast) {
      values.unshift(iconComponent);
    } else {
      values.push(iconComponent);
    }
  }

  let classNames = [styles.root];
  if (className) classNames.push(styles[className]);
  const classNamesCombined = classNames.join(' ');

  return (
    <Fab
      variant="extended"
      size="small"
      style={{ ...style }}
      className={classNamesCombined}
      disabled={disabled}
      onClick={onClickFunc}
    >
      {values}
    </Fab>
  );
}

ACButtonV2.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  Icon: PropTypes.elementType,
  iconLast: PropTypes.bool,
  onClickFunc: PropTypes.func,
  spanStyle: PropTypes.object,
  style: PropTypes.object,
  text: PropTypes.string,
};

ACButtonV2.defaultProps = {
  className: '',
  disabled: false,
  Icon: null,
  iconLast: false,
  onClickFunc: () => {},
  spanStyle: {},
  style: {},
  text: '',
};

export default ACButtonV2;
